import { Link, useNavigate } from "react-router-dom";
import { Building2, Check, ChevronsUpDown, FlaskConical, Plus } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const WorkspaceSwitcher = ({ workspaces, current }) => {
  const navigate = useNavigate();
  const real = workspaces.filter((w) => !w.is_sample);
  const sample = workspaces.find((w) => w.is_sample);
  const go = (id) => navigate(`/app/w/${id}`);

  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="workspace-select-dropdown"
        className="flex w-full items-center gap-3 rounded-md border border-white/15 bg-white/5 px-3 py-2.5 text-left transition-colors hover:bg-white/10">
        {current.is_sample ? <FlaskConical className="h-4 w-4 shrink-0 text-gold" /> : <Building2 className="h-4 w-4 shrink-0 text-gold" />}
        <span className="min-w-0 flex-1">
          <span className="block truncate text-sm font-medium" data-testid="current-workspace-name">{current.name}</span>
          <span className="block truncate text-[11px] text-white/50">{current.is_sample ? "Sample workspace" : current.account_type === "agent" ? (current.business_name || "Real estate agent") : current.account_type === "homeowner" ? "Homeowner" : "Workspace"}</span>
        </span>
        <ChevronsUpDown className="h-4 w-4 text-white/50" />
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-64" align="start">
        <DropdownMenuLabel className="text-xs text-slate-500">Your workspaces</DropdownMenuLabel>
        {real.length === 0 && <p className="px-2 py-1.5 text-sm text-slate-500">No property workspace yet</p>}
        {real.map((w) => (
          <DropdownMenuItem key={w.id} onClick={() => go(w.id)} data-testid={`workspace-option-${w.id}`}>
            <Building2 className="mr-2 h-4 w-4" /> <span className="flex-1 truncate">{w.name}</span>
            {w.id === current.id && <Check className="h-4 w-4" />}
          </DropdownMenuItem>
        ))}
        {sample && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => go(sample.id)} data-testid="workspace-option-sample">
              <FlaskConical className="mr-2 h-4 w-4 text-gold-dark" /> <span className="flex-1">Sample workspace</span>
              {sample.id === current.id && <Check className="h-4 w-4" />}
            </DropdownMenuItem>
          </>
        )}
        <DropdownMenuSeparator />
        <DropdownMenuItem asChild>
          <Link to="/app/new-workspace" data-testid="workspace-add-link"><Plus className="mr-2 h-4 w-4" /> Add another workspace</Link>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
